import React, { useContext, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { DOWNLOAD_SIMPLE } from '../../../../../../constants/images';
import { CLICK_ACTION, DOWNLOAD_REPORT, SUB_SECTION_PAYROLL_REPORTS } from '../../../../../../constants/tagManager';
import {
  DEFAULT_TOAST_DATA,
  DOWNLOAD_REPORT_RF_ERROR_TOAST,
  DOWNLOAD_REPORT_RF_SUCCESS_TOAST
} from '../../../../../../constants/toast';
import { CompanyContext } from '../../../../../../context/company/companyContext';
import Company from '../../../../../../services/api/companies/companies';
import TagManagerService from '../../../../../../services/gtm/tagManagerService';
import { TRANSLATIONS_GLOBAL } from '../../../../../../translations/commons';
import { TRANSLATIONS_REPORTS } from '../../../../../../translations/reports';
import { downloadFile } from '../../../../../../utils/utils';
import BdsTooltip from '../../../../BdsTooltip/BdsTooltip';
import BdsIconButton from '../../../../Buttons/BdsIconButton/BdsIconButton';
import LoadingModal from '../../../../Modals/LoadingModal/LoadingModal';
import Toast from '../../../../Toast/Toast';

interface IPayrollReportsTableActionsProps {
  id?: string;
  disabled?: boolean;
}

export const PayrollReportsTableActions = ({ id = '', disabled }: IPayrollReportsTableActionsProps) => {
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastData, setToastData] = useState(DEFAULT_TOAST_DATA);

  const { company } = useContext(CompanyContext);

  const { t } = useTranslation();

  const downloadRFReports = async () => {
    try {
      setLoading(true);
      const response = await Company.getCompanyPayRollReports(company.id, id);
      if (response.url) {
        downloadFile(response.url);
        setToastData(DOWNLOAD_REPORT_RF_SUCCESS_TOAST);
        TagManagerService.pushEvent(CLICK_ACTION, DOWNLOAD_REPORT, SUB_SECTION_PAYROLL_REPORTS);
      } else {
        setToastData(DOWNLOAD_REPORT_RF_ERROR_TOAST);
      }
    } catch {
      setToastData(DOWNLOAD_REPORT_RF_ERROR_TOAST);
    } finally {
      setLoading(false);
      setShowToast(true);
    }
  };

  const renderActionButton = () => (
    <BdsIconButton
      icon={DOWNLOAD_SIMPLE}
      variant="transparent"
      size="sm"
      action={downloadRFReports}
      className="reports-table-actions__button"
      aria-label={t(TRANSLATIONS_GLOBAL.downloadMonthlyReport.button)}
      disabled={disabled}
    />
  );

  const closeToast = () => setShowToast(false);

  return (
    <>
      {disabled ? (
        <BdsTooltip message={t(TRANSLATIONS_REPORTS.table.tooltip)} position="left" className="text-start">
          {renderActionButton()}
        </BdsTooltip>
      ) : (
        renderActionButton()
      )}
      <LoadingModal showModal={loading} description={t(TRANSLATIONS_REPORTS.rf.loadingModal)} />
      <Toast
        title={t(toastData.title)}
        description={t(toastData.description)}
        icon={toastData.icon}
        open={showToast}
        button={toastData.button}
        handleClose={closeToast}
      />
    </>
  );
};

export default PayrollReportsTableActions;
